import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth() || {};
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/autentificare"); return; }
    const session_id = m[1];
    (async () => {
      try {
        await api.post("/auth/google/callback", { session_id });
        if (refresh) await refresh();
        window.location.replace("/profil");
      } catch (e) {
        setError("Sesiune invalidă");
        setTimeout(() => nav("/autentificare"), 2000);
      }
    })();
  }, [nav, refresh]);

  return (
    <div className="min-h-[60vh] grid place-items-center">
      <div className="text-center">
        <div className="w-12 h-12 border-2 border-[#D4A63D] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-[#A0AABF]">{error || "Te autentificăm..."}</p>
      </div>
    </div>
  );
}
